import {
  MdVerified,
  MdStar,
  MdLocationOn,
  MdCalendarToday,
  MdWorkOutline,
  MdEventNote,
} from 'react-icons/md';
import { t } from '../../utils/i18n';
import { LANDING_AVATARS } from './constants';

const WEEK_DAYS = ['P', 'U', 'S', 'Č', 'P', 'S', 'N'];
const ACTIVE_DAYS = [1, 2, 4, 5, 6];

export default function HeroPreviewCard() {
  return (
    <div className="landing-hero-preview-wrap w-full max-w-[400px] mx-auto lg:mx-0 lg:ml-auto">
      <div
        className="landing-preview-float landing-preview-float--top hidden sm:flex"
        aria-hidden="true"
      >
        <MdWorkOutline className="text-base flex-shrink-0 text-primary-600 dark:text-primary-400" />
        <span>{t('landing.preview.floatingJobs')}</span>
      </div>

      <div
        className="landing-preview-float landing-preview-float--bottom hidden sm:flex"
        aria-hidden="true"
      >
        <MdEventNote className="text-base flex-shrink-0 text-primary-600 dark:text-primary-400" />
        <span>{t('landing.preview.floatingActivities')}</span>
      </div>

      <article className="landing-hero-preview rounded-2xl p-5 sm:p-6">
        <div className="flex items-center gap-3.5">
          <img
            src={LANDING_AVATARS.ana}
            alt=""
            className="w-14 h-14 rounded-full object-cover flex-shrink-0 border border-[var(--color-border)]"
            loading="lazy"
            referrerPolicy="no-referrer"
          />
          <div className="min-w-0 flex-1">
            <div className="flex items-center gap-2 flex-wrap">
              <h3 className="text-base font-semibold text-[var(--color-text)]">
                {t('landing.preview.name')}
              </h3>
              <span className="inline-flex items-center gap-0.5 text-sm font-medium text-[var(--color-text)]">
                <MdStar className="text-amber-500 text-sm" aria-hidden="true" />
                4.9
              </span>
            </div>
            <p className="flex items-center gap-1 text-sm text-[var(--color-text-muted)] mt-0.5">
              <MdLocationOn className="text-[15px] flex-shrink-0 opacity-70" aria-hidden="true" />
              {t('landing.preview.location')}
            </p>
          </div>
        </div>

        <div className="mt-3.5">
          <span className="inline-flex items-center gap-1 px-2.5 py-1 rounded-md text-xs font-medium landing-preview-verified">
            <MdVerified className="text-sm" aria-hidden="true" />
            {t('landing.preview.verified')}
          </span>
        </div>

        <div className="mt-5 landing-preview-calendar rounded-xl p-3.5">
          <div className="flex items-center justify-between mb-3">
            <span className="text-xs font-semibold text-[var(--color-text)] flex items-center gap-1.5">
              <MdCalendarToday className="text-sm opacity-70" aria-hidden="true" />
              {t('landing.preview.calendarTitle')}
            </span>
            <span className="text-xs font-medium text-primary-600 dark:text-primary-400">
              {t('landing.preview.nextActivity')}
            </span>
          </div>
          <div className="grid grid-cols-7 gap-1">
            {WEEK_DAYS.map((day, i) => {
              const active = ACTIVE_DAYS.includes(i);
              return (
                <div key={`${day}-${i}`} className="flex flex-col items-center gap-1">
                  <span className="text-[10px] font-medium text-[var(--color-text-muted)]">{day}</span>
                  <span
                    className={`w-full max-w-[2rem] aspect-square rounded-lg flex items-center justify-center text-[11px] font-semibold ${
                      active
                        ? 'landing-preview-day--active'
                        : 'landing-preview-day text-[var(--color-text-muted)]'
                    }`}
                  >
                    {active ? '●' : '·'}
                  </span>
                </div>
              );
            })}
          </div>
        </div>

        <div className="mt-4 flex items-center justify-between gap-3 pt-3.5 border-t border-[var(--color-border)]">
          <span className="text-sm text-[var(--color-text-muted)]">
            {t('landing.preview.availability')}
          </span>
          <span className="text-sm font-semibold text-[var(--color-text)]">
            {t('landing.preview.rate')}
          </span>
        </div>
      </article>
    </div>
  );
}
